var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrefleTrans(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 337,
    height: 343,
    fill: "none",
    viewBox: "0 0 337 343",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.2,
    d: "M304.632 293.309c22.151-42.059 13.379-80.773-18.326-115.088C344 147.875 351.551 72.671 312.03 30.724 293.64 11.193 271.092.37 244.37.127c-38.358-.338-66.828 17.553-86.344 49.96-31.05-29.188-66.746-39.245-106.49-22.477C14.511 43.216-6.419 72.805-6.337 113.188c.112 50.132 27.83 80.552 75.743 94.327-1.183.705-2.156 1.319-3.155 1.867-20.284 11.127-40.6 22.208-60.851 33.406-2.17 1.189-4.339 2.691-5.937 4.529-4.244 4.858-2.127 12.115 3.911 14.167 16.134 5.497 32.234 11.054 48.427 16.387 3.02.987 4.659 2.508 5.679 5.534 5.484 16.213 11.172 32.354 16.808 48.521 1.49 4.271 4.574 6.2 9.1 5.742 4.36-.439 7.162-2.936 9.197-6.645 6.659-12.175 13.383-24.323 20.107-36.471 5.249-9.479 10.524-18.946 15.838-28.49 13.003 46.21 42.197 73.882 90.83 75.997 37.719 1.64 67.685-15.358 85.272-48.75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrefleTrans);
export default __webpack_public_path__ + "static/media/TrefleTrans.5478991404cc04c63da9a8771cc591d2.svg";
export { ForwardRef as ReactComponent };